import React from "react"
import { NoItemsMessage } from ".."

const InsufficientPermissionsMessage = () => <NoItemsMessage>Insufficient permissions</NoItemsMessage>

export { InsufficientPermissionsMessage }
